export default "__VITE_ASSET__pb3by9gF__"